import { Button } from '@crehana/compass.ui/v2';
import { useTranslation } from '@crehana/i18n';
import clsx from 'clsx';

interface StepperProps {
  currentStep: number;
  setCurrentSep: (num: number) => void;
  activateUserByFlag?: () => void;
  primaryColor?: string | undefined;
}

const Stepper: React.FC<React.PropsWithChildren<StepperProps>> = ({
  currentStep,
  activateUserByFlag,
  setCurrentSep,
  primaryColor,
}) => {
  const { t } = useTranslation();

  const prev = () => {
    setCurrentSep(currentStep - 1);
  };

  const next = () => {
    if (currentStep > 2) {
      activateUserByFlag?.();
    } else {
      setCurrentSep(currentStep + 1);
    }
  };

  return (
    <div className="cui-container tw-w-full tw-flex tw-justify-end tw-items-center tw-my-4">
      <button
        type="button"
        className={clsx(
          'tw-btn-tertiary-xs tw-mr-3.2',
          primaryColor && `hover:tw-opacity-90`,
        )}
        // Use style because tw don't change bg color dynamically
        style={{ color: primaryColor }}
        onClick={() => prev()}
      >
        {t('STEPPER_BACK')}
      </button>
      <Button
        size="md"
        type="button"
        variant="primary"
        className={clsx(primaryColor && `hover:tw-opacity-90`)}
        // Use style because tw don't change bg color dynamically
        style={{ backgroundColor: primaryColor }}
        onClick={() => next()}
      >
        {t('STEPPER_NEXT')}
      </Button>
    </div>
  );
};
export default Stepper;
